/**
 * Copyright (c) Siemens 2016 - 2026
 * SPDX-License-Identifier: MIT
 */
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { elementCancel } from '@siemens/element-icons';
import { addIcons, SiIconComponent } from '@siemens/element-ng/icon';

@Component({
  selector: 'si-input-pill',
  imports: [SiIconComponent],
  templateUrl: './si-input-pill.component.html',
  styles: '.btn { cursor: pointer; }',
  changeDetection: ChangeDetectionStrategy.Default,
  host: {
    class: 'pill pe-0',
    '[class.pe-4]': 'hideClose()'
  }
})
export class SiInputPillComponent {
  /** Emits when the pill's close button is clicked. */
  readonly deletePill = output<void>();

  /**
   * Whether to hide the close button.
   *
   * @defaultValue false
   */
  readonly hideClose = input(false);

  protected readonly icons = addIcons({ elementCancel });
}
